<template>
  <div>
    <div class="wrapHeader">
      <el-form :inline="true" :model="checkOilConfigInfo" class="demo-form-inline">
        <el-form-item label="仓房名称">
          <el-input v-model="checkOilConfigInfo.wareName" placeholder="输入仓房名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getWareInfoList">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height+1}px`'>
      <div class='showView' :style='`height:${height-20}px;width:${width-30}px`'>
        <div class='setTabView' :style='`height:${height-50}px;width:${width-60}px`'>
          <div class='oilConfigList' :style='`height:${height-50}px`'>
            <el-table :data="oilMacConfigList" style="width: 100%" :border='true' :max-height="height-105" :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'>
              <el-table-column type="index" width="60" align='center' label="序号" :index="indexMethod"></el-table-column>
              <el-table-column prop="wareName" label="油罐名称" min-width="15%"></el-table-column>
              <el-table-column prop="wareHeight" label="雷达安装高度" min-width="15%"></el-table-column>
              <el-table-column prop="wareVolume" label="油罐体积" min-width="15%"></el-table-column>
              <el-table-column prop="density" label="油密度" min-width="15%"></el-table-column>
              <el-table-column prop="layerNum" label="测温点层数" min-width="15%"></el-table-column>
              <el-table-column prop="range" label="量程" min-width="15%"></el-table-column>
              <el-table-column prop="sensorMode" label="传感器模式" min-width="15%">
                <template slot-scope="scope">
                  <span :class='scope.row.sensorMode==1?"oilonLine":"oiloffLine"'>{{scope.row.sensorMode==1?"固体":"液体"}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="distanceOffset" label="偏移距离" min-width="15%"></el-table-column>
              <el-table-column prop="pointNum" label="分机点数" min-width="15%"></el-table-column>
              <el-table-column prop="status" label="通讯状态" min-width="15%">
                <template slot-scope="scope">
                  <span :class='scope.row.status==1?"oilonLine":"oiloffLine"'>{{scope.row.status==1?"在线":"离线"}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="20%" align='center'>
                <template slot-scope="scope">
                  <el-button @click.native.prevent="getConfig(oilMacConfigList[scope.$index].radarId,oilMacConfigList[scope.$index].status)" type="text" size="small">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="total" 
            :pageSize='checkOilConfigInfo.pageSize'
            :hide-on-single-page='true'
            :current-page='checkOilConfigInfo.pageNum'
            @current-change='setOilConfigChange'
            class='setPosition'>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="`${oilConfigInfo.wareName}配置信息`" :visible.sync="oilConfigView"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg dialog-oilConfig-bg"'>
      <div class='formWrap'>
        <el-form ref="oilConfigInfo" :model="oilConfigInfo" label-width="110px" class='oilConfigInfo' :rules='oilConfigRules'>
          <div class='dialog-setWrap dialog-oilConfig-wrap'>
            <el-form-item label="雷达安装高度" prop='wareHeight'>
              <el-input v-model="oilConfigInfo.wareHeight" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入1-30的数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">m</i></el-input>
            </el-form-item>
            <el-form-item label="油罐体积" prop='wareVolume'>
              <el-input v-model="oilConfigInfo.wareVolume" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">m³</i></el-input>
            </el-form-item>
            <el-form-item label="测温点层数" prop='layerNum'>
              <el-input v-model.number="oilConfigInfo.layerNum" placeholder="请输入1-16的数字"></el-input>
            </el-form-item>
            <el-form-item label="油密度" prop='density'>
              <el-input v-model="oilConfigInfo.density" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">kg/m³</i></el-input>
            </el-form-item>
             <el-form-item label="量程" prop='range'>
              <el-input v-model="oilConfigInfo.range" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">mm</i></el-input>
            </el-form-item>
            <el-form-item label="传感器模式" prop='sensorMode'>
              <el-select v-model="oilConfigInfo.sensorMode" placeholder="请选择">
                <el-option
                  v-for="item in sensorModeList"
                  :key="item.code"
                  :label="item.sensorMode"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="偏移距离" prop='distanceOffset'>
              <el-input v-model="oilConfigInfo.distanceOffset" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字"><i slot="suffix" style="font-style:normal;margin-right:5x;font-size:14px">mm</i></el-input>
            </el-form-item>
             <el-form-item label="分机点数" prop='pointNum'>
              <el-input v-model="oilConfigInfo.pointNum" oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入数字"></el-input>
            </el-form-item>
          </div>
          <el-form-item class='saveBtn'>
            <el-button type="primary" @click="saveConfig('oilConfigInfo')">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number,
  },
  watch: {
    wareId(newV, oldV) {
      this.getConfig()
    }
  },
  data(){
    const checkNum=(rule, value, callback) => {
      if(rule.field=='wareHeight'){
        if(value>30||value<1){
          callback(new Error('请输入1-30的数字'));
        }else if(String(value).indexOf(".")!=-1&&(String(value).split('.').length>2||String(value).split('.')[0]===''||String(value).split('.')[1]==='')){
          callback(new Error('请输入正确格式的数字'))
        }else if(String(value).indexOf('.')!=-1&&String(value).split('.')[1].length>2){
          callback(new Error('最多输入两位小数'))
        }else{
          callback()
        }
      }else if(rule.field=='layerNum'){
        if(value>16||value<1){
          callback(new Error('请输入1-16的数字'));
        }else{
          callback()
        }
      }else if(rule.field=='density'){
        if(String(value).indexOf(".")!=-1&&(String(value).split('.').length>2||String(value).split('.')[0]===''||String(value).split('.')[1]==='')){
          callback(new Error('请输入正确格式的数字'))
        }else if(String(value).indexOf('.')!=-1&&String(value).split('.')[1].length>2){
          callback(new Error('最多输入两位小数'))
        }else{
          callback()
        }
      }else if(rule.field=='wareVolume'){
        if(String(value).indexOf(".")!=-1&&(String(value).split('.').length>2||String(value).split('.')[0]===''||String(value).split('.')[1]==='')){
          callback(new Error('请输入正确格式的数字'))
        }else if(String(value).indexOf('.')!=-1&&String(value).split('.')[1].length>2){
          callback(new Error('最多输入两位小数'))
        }else{
          callback()
        }
      }
    }
    return{
      checkOilConfigInfo:{
        pageNum:1,
        pageSize:15,
        orderByColumn:'radarId',
        isAsc:'desc',
        wareName:''
      },
      oilMacConfigList:[],
      total:0,
      oilConfigInfo:{
        pointNum:120
      },
      sensorModeList:[{
        code:'0',
        sensorMode:'液体'
      },{
        code:'1',
        sensorMode:'固体'
      }],
      oilConfigView:false,
      loading:false,
      oilConfigRules:{
        wareHeight:[
          {trigger:'blur',message:'油罐高度不能为空',required:true},
          {trigger:'blur',validator:checkNum}
        ],
        density:[
          {trigger:'blur',validator:checkNum}
        ],
        layerNum:[
          {trigger:'blur',message:'测温点层数不能为空',required:true},
          {trigger:'change',message:'测温点层数为数字',type:'number'},
          {trigger:'blur',validator:checkNum}
        ],
        wareVolume:[
          {trigger:'blur',validator:checkNum}
        ]
      }
    }
  },
  created(){
    this.getWareInfoList()
  },
  methods:{
    getWareInfoList(){
      axios.get('/system/radar/list',{params:this.checkOilConfigInfo}).then(res=>{
        if(res){
          this.oilMacConfigList=res.rows;
          this.total=res.total
        }
      })
    },
    // 设置加载动画
    setConfigLoading(){
      this.loading=this.$loading({
        text:'请稍等',
        target:document.querySelector('.dialog-oilConfig-bg')
      })
    },
    getConfig(radarId,status){
      if(status==1){
        axios.get(`/system/radar/${radarId}`).then(res=>{
          if(res){
            this.oilConfigView=true;
            this.oilConfigInfo=res.data;
          }
        })
      }else{
        this.$message({
          message:'不能配置离线设备！',
          type:'error',
          duration:1000
        })
      }
    },
    saveConfig(obj){
      this.$refs[obj].validate((valid)=>{
        if(valid){
          this.setConfigLoading();
          axios.put('/system/radar/setupRadar',this.oilConfigInfo).then(res=>{
            this.loading.close();
            if(res){
              this.$message({
                message:res.msg,
                type:'success',
                duration:1000
              })
              this.oilConfigView=false;
              this.getWareInfoList()
            }
          })
        }else{
          return false
        }
      })
    },
    setOilConfigChange(val){
      this.checkOilConfigInfo.pageNum=val;
      this.getWareInfoList()
    },
    indexMethod(index){
      return (this.checkOilConfigInfo.pageNum-1)*this.checkOilConfigInfo.pageSize+index+1
    }
  }
}
</script>

<style>
.oilConfigWrap{
  top: 20px;
}
.oilConfigList{
  border: 1px solid #e4e7ed;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto
}
.oilonLine{color: #3BD14A}
.oiloffLine{color: #AFAFAF}
.dialog-oilConfig-bg{
  width: 740px;
}
.dialog-oilConfig-wrap{
  width: 700px;
  flex-wrap: wrap
}
.dialog-oilConfig-wrap .el-form-item{
  width: 50%
}
</style>